import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'regimen-expiry-strip',
  imports: [],
  templateUrl: './regimen-expiry-strip.component.html',
})
export class RegimenExpiryStripComponent implements OnInit {
  @Input() regimenExpiryBannerData: any;
  @Input() userFirstName: string;
  @Output() bannerClick = new EventEmitter<void>();
  @Input() page: string;
  constructor(
    private readonly eventLoggerService: EventLoggerService,
  ) {}

  ngOnInit(): void {
    const eventData = {
      bannerName: 'regimen_expiry_strip',
      page: this.page,
    }
    this.eventLoggerService.cleverTapEvent('impression', JSON.stringify({eventData}));
  }

  onBannerClick() {
    this.bannerClick.emit();
  }
}
